import React from "react";

const SubHeader = ({ children, styles="" }) => {
  return <div className={`flex flex-col sm:flex-row justify-between py-4 px-4 sm:px-8 sm:items-center bg-white min-h-[5.5rem] ${styles}`}>{children}</div>;
};

export default SubHeader;
